import { PDFViewer } from '@foxitsoftware/foxit-pdf-sdk-for-web-library/lib/PDFViewCtrl';

type jrFontMap = Parameters<InstanceType<typeof PDFViewer>['setJRFontMap']>[0][0];
type glyph = Partial<jrFontMap['glyphs']>;

enum Font_Style {
    unset = -1,
    normal = 0,
    italic = 1,
    bold = 2,
}

enum Font_Flags {
    unset = -1,
    FixedPitch = 1,
    Serif = 2,
    Symbolic = 4,
    Script = 8,

    Nonsymbolic = 32,
    Italic = 64,
    AllCap = 65536,
    SmallCap = 131072,

    ForceBold = 262144,
}

enum Font_Weight {
    unset = -1,
    lighter = 100,
    light = 200,
    lightItalic = 300,
    normal = 400 /* normal */,
    normalBold = 500,
    boldItalic = 600,
    bold = 700 /* bold */,
    bolder = 800,
    boldest = 900,
}

export const fontMaps: jrFontMap[] = [
    {
        nameMatches: [/Rage.*/i],
        glyphs: [
            {
                url: '/assets/fonts/RAGE.TTF',
                bold: Font_Weight.unset,
                flags: Font_Flags.unset,
                isBrotli: false,
            },
        ] as glyph,
    },
    {
        nameMatches: [/CALIBRI.*/i],
        glyphs: [
            {
                url: '/assets/fonts/Calibri/CALIBRII.TTF',
                bold: Font_Weight.normal,
                flags: Font_Flags.Italic,
                isBrotli: false,
            },
            {
                url: '/assets/fonts/Calibri/CALIBRILI.TTF',
                bold: Font_Weight.lightItalic,
                flags: Font_Flags.Italic,
                isBrotli: false,
            },
            {
                url: '/assets/fonts/Calibri/CALIBRIL.TTF',
                bold: Font_Weight.light,
                flags: Font_Flags.Italic,
                isBrotli: false,
            },
            {
                url: '/assets/fonts/Calibri/CALIBRIZ.TTF',
                bold: Font_Weight.boldItalic,
                flags: Font_Flags.ForceBold,
                isBrotli: false,
            },
            {
                url: '/assets/fonts/Calibri/CALIBRIB.TTF',
                bold: Font_Weight.bold,
                flags: Font_Flags.ForceBold,
                isBrotli: false,
            },
            {
                url: '/assets/fonts/Calibri/CALIBRI.TTF',
                bold: Font_Weight.unset,
                flags: Font_Flags.unset,
                isBrotli: false,
            },
        ] as glyph,
    },
    {
        nameMatches: [/Arial.*/i],
        glyphs: [
            {
                url: '/assets/fonts/Arial/ARIAL.TTF',
                bold: Font_Weight.unset,
                flags: Font_Flags.unset,
                isBrotli: false,
            },
            {
                url: '/assets/fonts/Arial/ARIALBD.TTF',
                bold: Font_Weight.bold,
                flags: Font_Flags.ForceBold,
                isBrotli: false,
            },
            {
                url: '/assets/fonts/Arial/ARIALI.TTF',
                bold: Font_Weight.normal,
                flags: Font_Flags.Italic,
                isBrotli: false,
            },
            {
                url: '/assets/fonts/Arial/ARIALBI.TTF',
                bold: Font_Weight.boldItalic,
                flags: Font_Flags.ForceBold | Font_Flags.Italic,
                isBrotli: false,
            },
        ] as glyph,
    },
    // Catch-all: any unmapped font falls back to Calibri (better proportional match than Arial for most fonts)
    {
        nameMatches: [/.*/],
        glyphs: [
            {
                url: '/assets/fonts/Calibri/CALIBRI.TTF',
                bold: Font_Weight.unset,
                flags: Font_Flags.unset,
                isBrotli: false,
            },
            {
                url: '/assets/fonts/Calibri/CALIBRIB.TTF',
                bold: Font_Weight.bold,
                flags: Font_Flags.ForceBold,
                isBrotli: false,
            },
            {
                url: '/assets/fonts/Calibri/CALIBRII.TTF',
                bold: Font_Weight.normal,
                flags: Font_Flags.Italic,
                isBrotli: false,
            },
            {
                url: '/assets/fonts/Calibri/CALIBRIZ.TTF',
                bold: Font_Weight.boldItalic,
                flags: Font_Flags.ForceBold | Font_Flags.Italic,
                isBrotli: false,
            },
        ] as glyph,
    },
];

// this is shown in text editor combo box
export const fontMapsInfo = [
    {
        name: 'Arial',
        style: Font_Style.normal,
        charset: 0,
    },
    {
        name: 'Calibri',
        style: Font_Style.normal,
        charset: 0,
    },
    {
        name: 'Rage',
        style: Font_Style.normal,
        charset: 0,
    },
];
